import { Outlet } from 'react-router-dom';

/**
 * 活动详情域路由壳
 */
export default function ActivityDetailShell() {
  return <Outlet />;
}
